<template>
  <input
    :type="type"
    :class="inputClass"
    :placeholder="placeholder"
    :value="value"
    v-mask="mask"
    @input="updateValue($event.target.value)"
  />
</template>

<script>
export default {
  name: 'masked-input',
  props: {
    value: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    inputClass: {
      type: String,
      default: 'form-control'
    },
    placeholder: {
      type: String,
      default: ''
    },
    mask: {
      type: [String, Array],
      required: true
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    }
  }
}
</script>
